/**
 * The practice-wide activity feed: every client's activity rows for the
 * caller's firm, newest first (`GET /api/law_firms/activity-log`). Same
 * filters and page shape as the per-client endpoint so `useActivityFeed`
 * can read either.
 */
import axiosInstance from "./axiosConfig";
import type {
  ForeignNationalActivityLogEvent,
  ForeignNationalActivityLogPage,
  ListForeignNationalActivityLogParams
} from "./types";
import { handleAPIError } from "./utils/errors";

export const LawFirmActivityAPI = {
  async listPage(
    params?: ListForeignNationalActivityLogParams
  ): Promise<ForeignNationalActivityLogPage> {
    try {
      const { data } = await axiosInstance.get<
        ForeignNationalActivityLogPage | ForeignNationalActivityLogEvent[]
      >("/law_firms/activity-log", { params });
      if (Array.isArray(data)) return { items: data, next_cursor: null };
      return {
        items: Array.isArray(data?.items) ? data.items : [],
        next_cursor:
          typeof data?.next_cursor === "string" && data.next_cursor
            ? data.next_cursor
            : null
      };
    } catch (error) {
      const apiError = handleAPIError(error);
      throw apiError;
    }
  }
};
